// extracted by mini-css-extract-plugin
export default {"banner":"fXLFQ","container":"Wk85T","title":"HM5ux","reduction":"ODdYz","description":"oLM7c","image":"DhlOl","zoom":"Q59LI"};